import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { Store } from '../../defaultState';

import { WalletStateT } from 'types';

export const selectWalletState = (state: Store): WalletStateT => state.wallet;

export const balanceSelector: (state: Store) => string | undefined = createDraftSafeSelector(
  selectWalletState,
  (walletState: WalletStateT) => walletState.nativeBalance?.formatted
);

export const instrumentPairBalanceSelector = createDraftSafeSelector(
  selectWalletState,
  (walletState: WalletStateT) => walletState.instrumentPairBalance
);
